module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@xdbchain/js-stellar-sdk/~/axios/index.js
// module id = 162
// module chunks = 0